import { call, put } from "redux-saga/effects";
import {
    API_BASE_URL,
    extractErrorMessage,
    getRequest,
} from "../../../api";
import {
    searchKmsFail,
    searchKmsSuccess,
    setKmsSearchLoading,
} from "../actions/kmsSearchActions";

const getUidHeaderAndToken = () => ({
    token: sessionStorage.getItem("token") || localStorage.getItem("token"),
});

const buildQueryString = (params = {}) => {
    const searchParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
        if (value === undefined || value === null || value === "") {
            return;
        }
        searchParams.append(key, value);
    });

    const qs = searchParams.toString();
    return qs ? `?${qs}` : "";
};

export function* searchKmsSaga(action) {
    const { token } = getUidHeaderAndToken();
    const url = `${API_BASE_URL}/api/kms/search${buildQueryString(action.payload)}`;

    yield put(setKmsSearchLoading(true));
    try {
        const response = yield call(getRequest, { url, token });
        yield put(searchKmsSuccess(response.data));
    } catch (error) {
        yield put(searchKmsFail(extractErrorMessage(error, "Erreur lors de la recherche KMS")));
    } finally {
        yield put(setKmsSearchLoading(false));
    }
}
